import { createFileRoute, Link } from '@tanstack/react-router';
import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { AuthFrame } from '@/components/AuthFrame';
import { authClient } from '@/lib/auth-client';

export const Route = createFileRoute('/reset-password')({
  validateSearch: z.object({ token: z.string().optional(), error: z.string().optional() }),
  component: ResetPassword
});

function ResetPassword() {
  const { t } = useTranslation();
  const { token, error: linkError } = Route.useSearch();
  const [password, setPassword] = useState('');
  const [state, setState] = useState<'form' | 'done' | 'failed'>(token && !linkError ? 'form' : 'failed');
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    const { error } = await authClient.resetPassword({ newPassword: password, token: token! });
    setState(error ? 'failed' : 'done');
  };
  return (
    <AuthFrame title={t('auth.resetTitle')}>
      {state === 'form' && (
        <form onSubmit={submit} className="space-y-3">
          <label className="block">
            <span className="mb-1 block text-sm">{t('auth.newPassword')}</span>
            <input className="input w-full" type="password" autoComplete="new-password" minLength={12} value={password} onChange={(e) => setPassword(e.target.value)} required autoFocus />
            <span className="text-base-content/60 text-xs">{t('auth.passwordHint')}</span>
          </label>
          <button type="submit" className="btn btn-primary w-full">
            {t('auth.setPassword')}
          </button>
        </form>
      )}
      {state === 'done' && <p className="text-sm">{t('auth.resetDone')}</p>}
      {state === 'failed' && <p className="text-error text-sm">{t('auth.resetInvalid')}</p>}
      <Link to="/login" className="link mt-4 block text-sm">
        {t('auth.toSignIn')}
      </Link>
    </AuthFrame>
  );
}
